import * as React from 'react';
import * as VerifyDeviceActions from 'user/VerifyDeviceActions';
// @ts-ignore
import { ConfirmableDeviceType } from 'entities/Device';
import ClaimDevice from 'user/components/ClaimDevice';
import {
  ClaimDevice_claimDevice,
  ClaimDevice as ClaimDeviceMutation,
} from 'user/mutations/__generated__/ClaimDevice';

export type Props = {
  claimToken: string;
  deviceAddress: string;
  deviceType: ConfirmableDeviceType;
  onDeviceClaimed: (claimDevice: ClaimDevice_claimDevice) => void;
  onMergingAccounts: (claimDevice: ClaimDevice_claimDevice) => void;
};

type State = {
  classNames: string[];
  mergeAccounts: boolean;
  displayMergeAccountsConfirmation: boolean;
  submitDisabled: boolean;
};

export default class ClaimDeviceContainer extends React.Component<Props, State> {
  state: State = {
    classNames: [],
    mergeAccounts: false,
    displayMergeAccountsConfirmation: false,
    submitDisabled: false,
  };

  async componentDidMount() {
    await this.getClaimAccountScreen();
  }

  getClaimAccountScreen = async () => {
    if (!this.props.claimToken) {
      return;
    }

    const resp = await VerifyDeviceActions.getClaimAccountScreen(this.props.claimToken);
    if (resp) {
      this.setState({
        classNames: resp.claimAccountScreen?.classNames ?? [],
      });
    }
  };

  claimDevice = async () => {
    this.setState({ submitDisabled: true });

    const resp = await VerifyDeviceActions.claimDevice(this.props.claimToken, false);

    if (resp) {
      this.props.onDeviceClaimed(resp.claimDevice);
    }

    this.setState({ submitDisabled: false });
  };

  mergeAccounts = () => {
    this.setState({ displayMergeAccountsConfirmation: true });
  };

  confirmMergeAccounts = async () => {
    this.setState({ submitDisabled: true });

    const resp = await VerifyDeviceActions.claimDevice(this.props.claimToken, true);

    if (resp) {
      this.props.onMergingAccounts(resp.claimDevice);
    }

    this.setState({ submitDisabled: false });
  };

  cancelMergeAccounts = () => {
    this.setState({ displayMergeAccountsConfirmation: false });
  };

  claimDeviceOrMergeAccounts = async () => {
    if (this.state.mergeAccounts) {
      this.mergeAccounts();
    } else {
      this.claimDevice();
    }
  };

  render() {
    return (
      <ClaimDevice
        deviceClasses={this.state.classNames}
        claimToken={this.props.claimToken}
        deviceType={this.props.deviceType}
        deviceAddress={this.props.deviceAddress}
        mergeAccounts={this.state.mergeAccounts}
        submitDisabled={this.state.submitDisabled}
        displayMergeAccountsConfirmation={this.state.displayMergeAccountsConfirmation}
        onMergeAccountsChange={mergeAccounts => this.setState({ mergeAccounts })}
        onClaim={this.claimDeviceOrMergeAccounts}
        onConfirmMerge={this.confirmMergeAccounts}
        onCancelMerge={this.cancelMergeAccounts}
      />
    );
  }
}
